import React, { useEffect, useState } from "react";
import LiquidGlass from "./LiquidGlass";

// Thin slider track. While dragging, it thickens and a Liquid Glass lens rides the value.
// `accent` fills it with the system blue, as Now Playing's progress bar does.
const GlassTrack = ({ value, min = 0, max = 100, step = 1, onChange, label, valueText, accent = false }) => {
  const [dragging, setDragging] = useState(false);

  // The pointer can be released outside the slider, so listen on the window.
  useEffect(() => {
    if (!dragging) return undefined;
    const stop = () => setDragging(false);
    window.addEventListener("pointerup", stop);
    window.addEventListener("pointercancel", stop);
    return () => {
      window.removeEventListener("pointerup", stop);
      window.removeEventListener("pointercancel", stop);
    };
  }, [dragging]);

  const fraction = max > min ? Math.min(1, Math.max(0, (value - min) / (max - min))) : 0;

  return (
    <div
      className={`cc-track ${accent ? "cc-track--accent" : ""} ${dragging ? "is-dragging" : ""}`}
      style={{ "--v": fraction }}
    >
      <span className="cc-track-fill" />
      <LiquidGlass className="cc-track-thumb" bezel={9} depth={16} blur={0.4} tone={false} aria-hidden="true" />
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        onPointerDown={() => setDragging(true)}
        aria-label={label}
        aria-valuetext={valueText}
      />
    </div>
  );
};

export default GlassTrack;
